<!--
 * @Description: 报名成功信息页
 * @Author: 山淑兰
 * @Date: 2019-11-11 17:39:20
 * @LastEditTime: 2020-07-15 18:03:43
 * @LastEditors: 山淑兰
 -->
<template>
    <div id="signUpInfo">
        <Loading v-if="show"></Loading>
        <div class="signUpInfo_container">
            <div class="nav" v-if="navShow">
                <a :href="navhomeUrl" target="_top">首页</a>
                > <a>会议直播</a>
            </div>
            <div class="banner-img" v-if="meetingInfo.MobileBannerImage!=null&&red!='im'">
                <img :src="meetingInfo.MobileBannerImage">
            </div>
            <div class="signUpInfo_content">
                <div id="meeting_info" class="commonW">
                    <div v-if="schedule!=null && schedule.length>0">
                        <div class="schedule-date">
                            <div class="schedule-date-item" v-for="(item,index) in schedule" :key='index' :class="{'active':active==index}" @click="changeDate($event,index)">
                                <div class="item-liveWeek">
                                    {{item.LiveWeek}}
                                </div>
                                <div class="item-liveDate">
                                    {{item.LiveDate}}
                                </div>
                            </div>
                        </div>
                        <div class="schedule-meeting" v-if="scheduleList!=null && scheduleList.length>0">
                            <div class="meeting-list" v-for="(item,index) in scheduleList" :key='index'>
                                <a :href="item.LiveLink" target="_top">
                                  <div class="meeting-liveBanner">
                                      <img :src="item.LiveBanner">
                                  </div>
                                  <div class="meeting-con">
                                      <div class="meeting-title">
                                          {{item.Title}}
                                      </div>
                                      <div class="meeting-live">
                                          <div class="meeting-liveTimer">
                                              时间:{{item.LiveTimer}}
                                          </div>
                                          <div class="meeting-liveStatus">
                                            <span class="liveStatus liveStatus1" v-if="item.LiveStatus==0">
                                                  未开始
                                              </span>
                                              <span class="liveStatus liveStatus2" v-if="item.LiveStatus==1">
                                                  正在直播
                                              </span>
                                              <span class="liveStatus liveStatus3" v-if="item.LiveStatus==2">
                                                  已结束
                                              </span>
                                              <span class="liveStatus liveStatus3" v-if="item.LiveStatus==3">
                                                  观看回放
                                              </span>
                                          </div>
                                      </div>
                                  </div>
                                </a>
                            </div>
                        </div>
                        <div class="noDate" v-else>
                            该日期暂无会议信息
                        </div>
                    </div>
                    <div class="noDate" v-else>
                        暂无会议信息
                    </div>
                </div>
                <div class="loading" v-if="loading">
                    <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...</van-loading>
                </div>
            </div>
        </div>
        <Footer v-if="footShow"  :footInfo="this.footInfo"></Footer>
        <Nav v-if="fNavShow"></Nav>
    </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import Footer from '@components/Footer.vue'
import Nav from './../SignUp/components/navigation.vue'
import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'
export default {
    name: 'liveInfo',
    components: {
        Footer,
        Nav,
        Loading,
    },
    data() {
        return {
          publicSignup: {}, //通用js
          params: {
              m: '',
              red: '',
          },
          meetingInfo: '',
          show: false,
          loading: false,
          schedule: [],
          scheduleList: [],
          active: 0,
          red: '',
          navShow: true,
          navhomeUrl: '',
          fNavShow: true,
          footShow: true,
		  footInfo: {
			LogoTxt: '',
			LogoLink: '',
			LogoImg: '',
		  },
        }
    },
    created() {
        this.params = this.$route.query
        this.red = this.params.red
        this.publicSignup = new publicSignup()
        console.log(this.publicSignup)
        let opt = { m: this.params.m }
        this.initmeeting(opt)
        this.scheduleGet(opt)
        this.init()
    },
    mounted() {
        //this.swiperInit()
    },
    methods: {
        async init(){
          if (this.$route.path === '/signup/meetingsignup') {
            this.fNavShow = false
          }else{
            this.fNavShow = true
          }
          console.log(this.$route.path)
        },
        async initmeeting(opt) {
            this.show = true
            this.meetingInfo = await this.publicSignup.init(opt, this)
            if (this.meetingInfo.Code === 1000) {
                this.show = false
				this.footInfo.LogoTxt = this.meetingInfo.LogoTxt
				this.footInfo.LogoLink = this.meetingInfo.LogoLink
				this.footInfo.LogoImg = this.meetingInfo.LogoImg
                if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
                    this.navShow = false
                } else {
                    this.navShow = true
                    this.navhomeUrl = this.meetingInfo.HomeUrl
                }
                if( this.meetingInfo.isshowlogo == 0 ){
                    this.footShow = true
                }else{
                    this.footShow = false
                }
            } else {
                this.$notify({
                    massage: this.meetingInfo.Msg,
                    type: 'danger',
                    duration: '3000',
                })
            }
        },
        /**
         * 初始化报名用户数据
         */
        async scheduleGet(opt) {
            try {
                this.loading = true
                let res = await this.$http.liveMeeting(opt)
                console.log(res)
                if (res.Code === 0) {
                    this.loading = false
                    this.schedule = res.LiveData
                    if (this.schedule != null && this.schedule.length > 0) {
                        this.scheduleList = this.schedule[this.active].LiveDatas
                    }
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'primary',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },

        changeDate(e, index) {
            let that = this
            that.active = index
            that.scheduleList = []
            that.scheduleList = that.schedule[index].LiveDatas
        },

        //微信分享
        async initShare(title, desc, link, imgUrl) {
            try {
                const headRes = await this.$http.csData({
                    url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                    ),
                })
                console.log(headRes, 'headRes')
                const _Wx = new wxShare({
                    opt: headRes,
                })
                _Wx.ready().then((wx) => {
                  _Wx.share(title, desc, link, imgUrl)
                  console.log(wx)
                })
                //this.headRess = _Wx
            } catch (err) {
                console.log(err)
            }
        },
    },
}
</script>
<style lang="scss">
.payDialog {
    .van-dialog__message {
        font-size: 32px;
        height: 100px;
        line-height: 100px;
    }

    .van-button {
        height: 100px;
        line-height: 100px;
    }

    .van-button__text {
        font-size: 32px;
    }

}

.swiper-pagination-bullet {
    width: 14px !important;
    height: 14px !important;
}
</style>
<style lang="scss" scoped>
.signUpInfo-banner {
    width: 100%;
    overflow: hidden;
    position: relative;
}

.signUpInfo-banner .swiper-slide {
    position: relative;
    text-align: center;
}

.signUpInfo-banner img {
    max-width: 100%;
    display: block;
}

.commonW {
    width: 100%;
    margin: 0 auto;
}

// ----------
#signUpInfo {
    .signUpInfo_container {
        padding-bottom: 100px;

        .live-data {
            border-top: 1px dashed #e2e8f0;
            display: flex;

            .liveDiv {
                flex: 1;
                text-align: center;
                padding: 20px 0;
                font-size: 26px;

                p {
                    color: #1e293b;
                    padding: 5px 0;
                }

                p:last-child span {
                    font-size: 34px;
                    color: #3b82f6;
                    font-weight: bold;
                }
            }
        }

        .note {
            text-align: center;
            font-size: 22px;
            color: #64748b;
            margin-top: 20px;
        }

        .pay-btns {
            height: 60px;
            margin-top: 20px;
            border-top: 1px dashed #e2e8f0;
            padding-top: 20px;

            .pay-btn {
                background: linear-gradient(135deg, #3b82f6, #6366f1);
                width: 200px;
                height: 60px;
                text-align: center;
                line-height: 60px;
                color: #fff;
                float: right;
                margin-right: 20px;
            }
        }

        .signUpInfo_content {
            .signUpInfo-banner {
                >img {
                    width: 100%;
                }
            }
        }
    }

    .van-dialog {
        width: 70%;
        text-align: center;
        font-size: 32px;
        padding-top: 20px;

        .van-dialog__content {
            margin: 20px;
        }

        .van-button {
            font-size: 32px;
            line-height: 60px;
            height: 60px;
        }
    }
}

.schedule-date {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 20px 0;
}

.schedule-date-item {
    cursor: pointer;
    float: left;
    background: #f8fafc;
    border-radius: 8px;
    height: 100px;
    width: calc((100% - 52px)/4);
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    flex-direction: column;
}

.schedule-date-item:nth-child(4n) {
    margin-right: 0;
}

.schedule-date-item.active {
    border: 2px solid #3b82f6;
    background: #fff;
}

.item-liveWeek {
    font-size: 26px;
    line-height: 37px;
    color: #64748b;
}

.item-liveDate {
    line-height: 48px;
    font-size: 34px;
    font-weight: 600;
    color: #1e293b;
}


.schedule-meeting {
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
}

.meeting-list {
    width: calc((100% - 100px)/2);
    float: left;
    display: flex;
    margin-bottom: 20px;
    background-color: #ffffff;
    box-shadow: 0 0 20px rgba(0, 0, 0, .1);
    border-radius: 10px;
    overflow: hidden;
    padding: 20px;
    margin-right: 20px;
    flex-direction: column;
}

.meeting-list:nth-child(2n) {
    margin-right: 0;
}

.meeting-liveBanner {
    width: 100%;
    height: 162px;
}

.meeting-liveBanner img {
    display: block;
    width: 100%;
    height: 100%;
}

.meeting-con {
    margin-top: 10px;
}

.meeting-title {
    font-size: 26px;
    color: #1e293b;
    line-height: 40px;
    height: 80px;
    overflow: hidden;
}


.meeting-live {
    margin-top: 10px;
    display: flex;
}

.meeting-liveTimer {
    flex: 1;
    color: #64748b;
    line-height: 50px;
    font-size: 24px;
}

.noDate {
    text-align: center;
    padding: 20px;
    font-size: 26px;
    color: #64748b;
}

.meeting-liveStatus {
    width: 140px;
}

.liveStatus {
    display: block;
    width: 140px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-radius: 25px;
    font-size: 24px;
}

.liveStatus a {
    display: block;
    width: 100%;
    height: 100%;
}

.liveStatus1 {
    border: 1px solid #e2e8f0;
    color: #64748b
}

.liveStatus2 {
    border: 1px solid #3b82f6;
    color: #3b82f6;
}

.liveStatus3 {
    border: 1px solid #e2e8f0;
    color: #64748b
}

.liveStatus1 a,
.liveStatus3 a {
    color: #64748b
}

.liveStatus2 a {
    color: #3b82f6;
}

.nav {
    height: 76px;
    font-size: 26px;
    line-height: 76px;
    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%) url(../../assets/home.png) no-repeat 20px center;
    background-size: 30px 30px;
    color: #fff;
    padding: 0 30px 0 60px;

    a {
        color: #fff;
    }
}

.banner-img img {
    width: 100%;
}

#foot {
    position: absolute;
    width: 100%;
    height: 50px;
    text-align: center;
    bottom: 0;
    border-top: 1px solid #e2e8f0;
    background: #f8fafc;
    padding: 10px;
    color: #64748b;
    line-height: 50px;
    margin: 0 auto;
}

#foot img {
    display: inline-block;
    vertical-align: top;
    height: 50px;
    margin-right: 10px;
}
</style>